import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Group, GroupType } from "@domain/group/group";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { useModalTools } from "@ui/modals/modalContext";
import { gap, mobile } from "@ui/styles/utils";
import { SubscriptionSummary } from "./subscriptionSummary";

interface UnauthorizedAccessShareroomProps extends React.HTMLAttributes<HTMLDivElement> {
	group?: GroupType;
	close?: () => void;
	shareroom: Group;
}

export const UnauthorizedAccessShareroom: React.FC<UnauthorizedAccessShareroomProps> = ({
	shareroom,
	close,
	...htmlProps
}) => {
	const { createModal } = useModalTools();
	return (
		<Container {...htmlProps}>
			<Info>{I18n.t("shareroom.subscription.renew.description")}</Info>
			<StyledButton onClick={() => createModal((close) => <SubscriptionSummary shareroom={shareroom} close={close} />)}>
				<span>{I18n.t("shareroom.subscription.renew.title")}</span>
			</StyledButton>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	${gap(25)};
	display: flex;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 80px;
`;

const Info = styled.div`
	${({ theme }) => theme.textStyles.description};
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 30px;
	@media ${mobile} {
		font-size: 13px;
	}
`;

const StyledButton = styled(LoadingButton)`
	padding: 10px !important;
	font-size: 13px;
	margin-top: 40px;
`;
